import { render } from "./AdminDictionariesView.vue?vue&type=template&id=5d69a141&scoped=true"
import script from "./AdminDictionariesView.vue?vue&type=script&lang=js"
export * from "./AdminDictionariesView.vue?vue&type=script&lang=js"

import "./AdminDictionariesView.vue?vue&type=style&index=0&id=5d69a141&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d69a141"]])

export default __exports__